(() => {
  'use strict';

  const V = '2.0.2-staging';
  const F = '.sr-headless-checkout,.shiprocket-headless,[data-sr-headless-checkout],[data-shiprocket-headless]';
  const C = 'button[name="checkout"],input[name="checkout"]';
  const A = '.shopify-payment-button,.additional-checkout-buttons,.cart__dynamic-checkout-buttons';
  let blocked = 0, timer = 0, notice;

  const fastrrReady = () => !!document.querySelector(F);
  const isFastrr = (el) => el instanceof Element && (el.matches(F) || !!el.closest(F));
  const isDiscount = (el) => el instanceof Element && (
    el.matches('[data-zyvira-discount-apply="true"],[data-zyvira-discount-fixed="true"]') ||
    (!!el.closest('.discount-content') && el.matches('.send-icon,button,input'))
  );
  const isNative = (el) => el instanceof Element && el.matches(C) && !isDiscount(el) && !isFastrr(el);
  const nativeControls = () => Array.from(document.querySelectorAll(C)).filter(isNative);

  function fixDiscount() {
    document.querySelectorAll('.discount-content .send-icon[name="checkout"],.discount-content #checkout[name="checkout"],[data-zyvira-discount-apply="true"]').forEach((b) => {
      b.type = 'button';
      b.removeAttribute('name');
      b.removeAttribute('form');
      if (!b.id || b.id === 'checkout') b.id = 'zyvira-apply-cart-discount';
      b.dataset.zyviraDiscountApply = 'true';
      b.dataset.zyviraDiscountFixed = 'true';
      b.setAttribute('aria-label', 'Apply discount code');
      if (b.dataset.zyviraDiscountListener === 'true') return;
      b.dataset.zyviraDiscountListener = 'true';
      b.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const input = b.closest('.discount-content')?.querySelector('input[name="discount"]');
        const code = (input?.value || '').trim();
        if (!code) return input?.focus();
        const back = `${location.pathname}${location.search}` || '/cart';
        location.assign(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(back)}`);
      });
    });
  }

  function hideAccelerated() {
    document.querySelectorAll(A).forEach((el) => {
      if (isFastrr(el)) return;
      el.dataset.zyviraNativeAcceleratedHidden = 'true';
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    });
  }

  function arm() {
    nativeControls().forEach((el) => {
      el.dataset.zyviraCheckoutGuard = 'armed';
      el.dataset.zyviraNativeCheckoutProtected = 'true';
    });
  }

  function state() {
    const n = nativeControls();
    const a = Array.from(document.querySelectorAll(A)).filter((el) => !isFastrr(el));
    const s = {
      version: V,
      fastrrReady: fastrrReady(),
      fastrrElements: document.querySelectorAll(F).length,
      protectedNativeCheckoutElements: n.length,
      acceleratedHiddenElements: a.filter((el) => el.dataset.zyviraNativeAcceleratedHidden === 'true').length,
      fixedDiscountButtons: document.querySelectorAll('[data-zyvira-discount-fixed="true"]').length,
      failClosedArmed: n.every((el) => el.dataset.zyviraCheckoutGuard === 'armed'),
      blockedAttempts: blocked
    };
    document.documentElement.dataset.zyviraFastrrReady = s.fastrrReady ? 'true' : 'false';
    document.documentElement.dataset.zyviraCheckoutFailClosed = s.failClosedArmed ? 'armed' : 'not-armed';
    return s;
  }

  function refresh() {
    fixDiscount();
    hideAccelerated();
    arm();
    const s = state();
    if (window.ZyviraPhase1C) window.ZyviraPhase1C.lastSnapshot = s;
    return s;
  }

  function showNotice() {
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'zyvira-phase1c-checkout-guard-notice';
      notice.setAttribute('role', 'alert');
      notice.textContent = 'Secure checkout is still loading. Please wait a moment and try again.';
      notice.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483647;max-width:min(92vw,460px);padding:12px 16px;border-radius:10px;background:#570517;color:#fff;font:600 14px/1.45 Arial,sans-serif;text-align:center';
      document.body.appendChild(notice);
    }
    notice.hidden = false;
    clearTimeout(showNotice.t);
    showNotice.t = setTimeout(() => { if (notice) notice.hidden = true; }, 3000);
  }

  function stop(e, why) {
    e.preventDefault();
    e.stopImmediatePropagation();
    blocked += 1;
    window.ZyviraPhase1C.blockedAttempts = blocked;
    window.ZyviraPhase1C.lastBlockedReason = why;
    showNotice();
    refresh();
  }

  function start() {
    document.addEventListener('click', (e) => {
      const control = e.target.closest?.(C);
      if (isNative(control) && !fastrrReady()) stop(e, 'click');
    }, true);
    document.addEventListener('submit', (e) => {
      if (isNative(e.submitter) && !fastrrReady()) stop(e, 'submit');
    }, true);

    window.ZyviraPhase1C = {
      version: V,
      blockedAttempts: 0,
      lastBlockedReason: null,
      lastSnapshot: null,
      fastrrReady: () => fastrrReady(),
      snapshot: () => refresh()
    };

    refresh();
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(refresh, 50);
    }).observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(refresh, 5000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
